import avatar from "./avatar.svg";
import placeholder from "/images/placeholder.png";

const IMAGES = { avatar, placeholder };

export default IMAGES;
